<template>
  <!-- 
    @param tableData 父组件传值
    @param loading [Boolean] 加载提示
    @param border [Boolean] table边筐
  -->
  <div class="table-class">
    <el-table
      ref="multipleTable"
      :data="tableData"
      v-loading="loading"
      element-loading-text="Loading"
      :border="border"
      :stripe="stripe"
      fit
      size="small"
      highlight-current-row
      tooltip-effect="dark"
      style="width: 100%"
      @sort-change="handleSortChange"
      @selection-change="handleSelectionChange"
      :header-cell-style="{ background: '#F8F8F8', 'text-align': 'center' }"
      :show-header="isShowHeader"
      :row-key="getRowKey"
    >
      <!-- '#E0EBF7' -->
      <!-- 
          @name 展开查看详情
          @param tableLabel 父组件传值
          @param label [string] 名称
          @param render 配置格式化数据
      -->
      <el-table-column
        :type="type"
        v-if="type == 'selection'"
        :reserve-selection="true"
        align="center"
      ></el-table-column>
      <el-table-column v-if="isExpand" type="expand" fixed="left" width="50">
        <template slot-scope="scope">
          <!--  描述列表 -->
          <div style="padding: 10px 20px">
            <el-descriptions class="margin-top" :column="2" border>
              <el-descriptions-item
                v-for="(item, index) in tableLabel"
                :key="index"
                :label="item.label"
                contentStyle="max-width: 300px; word-break: break-all"
              >
                <span v-if="item.render">
                  <expand-dom
                    v-if="item.render"
                    :column="item"
                    :row="scope.row"
                    :render="item.render"
                    :index="index"
                  ></expand-dom>
                </span>
                <span v-else-if="item.param == 'xId'">{{
                  (currentPage - 1) * pageSize + scope.$index + 1
                }}</span>
                <span v-else>{{
                  scope.row[item.param]
                }}</span></el-descriptions-item
              >
            </el-descriptions>
          </div>
        </template>
      </el-table-column>
      <!--
          @name 操作
          @param tableOption 父组件传值
          @param label [string] 名称
          @param width [string] 宽度
          @param options [array] 按钮数组
          @param type 按钮类型
          @param icon 按钮图标
          @param handleButton 按钮方法 
      -->

      <el-table-column
        v-if="tableOption.label"
        :fixed="tableOption.fixed"
        :width="tableOption.width"
        :min-width="tableOption.minWidth"
        :label="tableOption.label"
        align="center"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <slot :row="scope.row" :index="scope.$index"></slot>
          <template v-for="(item, index) in tableOption.options">
            <el-button
              :key="index"
              :disabled="item.disabled ? item.disabled(scope.row) : false"
              :type="item.type"
              :size="item.size ? item.size : ''"
              :icon="item.icon"
              @click="handleButton(item.methods, scope.row, scope.$index)"
              class="option-btn"
              >{{ item.label }}</el-button
            >
          </template>
        </template>
      </el-table-column>
      <!-- 
          @name 标题+表格数据显示
          @param tableLabel 父组件传值
          @param width 【string】宽度
          @param align 【string】对齐方式
          @param label [string] 名称
          @param sortable [Boolean] 排序
          @param render 配置格式化数据
      -->
      <template v-for="(item, index) in tableLabel">
        <el-table-column
          :key="index"
          v-if="item.show"
          :width="item.width ? item.width : ''"
          :align="item.align"
          :label="item.label"
          :prop="item.param"
          :sortable="item.sortable ? 'custom' : false"
          :show-overflow-tooltip="item.isShowTooltip == false ? false : true"
        >
          <template slot-scope="scope">
            <expand-dom
              v-if="item.render"
              :column="item"
              :row="scope.row"
              :render="item.render"
              :index="index"
            >
            </expand-dom>
            <span v-else-if="item.param == 'xId'">{{
              (currentPage - 1) * pageSize + scope.$index + 1
            }}</span>
            <div v-else>
              <span v-if="item.type == 'img'">
                <el-popover
                  placement="right"
                  title
                  trigger="click"
                  width="500"
                  height="500"
                >
                  <el-image
                    slot="reference"
                    :src="scope.row[item.param]"
                    :alt="scope.row[item.param]"
                    style="max-height: 200px; max-width: 200px"
                  ></el-image>
                  <el-image :src="scope.row[item.param]"></el-image>
                </el-popover>
              </span>
              <span v-else>{{ scope.row[item.param] }}</span>
            </div>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <el-pagination
      v-if="isPage"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      class="pagination-class"
    ></el-pagination>
  </div>
</template>

<script>
/**
 * @name 表格封装
 * @export TableElement
 * @param loading [Boolean] 配置加载提示
 * @param tableData [Array] 数据
 * @param tableMain [Array] 数据详情
 * @param tableLabel [Array] 配置表格头部
 * @param tableOption [Object] 操作按钮
 * @param border [Boolean] 配置边筐
 */
export default {
  props: {
    rowKey: {
      type: String,
      default: "id",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    tableMain: {
      type: Array,
      default: () => {
        return [];
      },
    },
    tableLabel: {
      type: Array,
      default: () => {
        return [];
      },
    },
    tableOption: {
      type: Object,
      default: () => {
        return {};
      },
    },
    type: {
      type: String,
      default: "expand",
    },
    border: {
      type: Boolean,
      default: true,
    },
    stripe: {
      type: Boolean,
      default: false,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    total: {
      type: Number,
      default: 0,
    },
    isPage: {
      type: Boolean,
      default: true,
    },
    isShowHeader: {
      type: Boolean,
      default: true,
    },
    isExpand: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    expandDom: {
      functional: true,
      props: {
        row: Object,
        render: Function,
        index: Number,
        column: {
          type: Object,
          default: null,
        },
      },
      render: (h, ctx) => {
        const params = {
          row: ctx.props.row,
          index: ctx.props.index,
        };
        if (ctx.props.column) params.column = ctx.props.column;
        return ctx.props.render(h, params);
      },
    },
  },
  methods: {
    // methods:按钮名称 row：同一行的数据 index：第几行（0开始）
    handleButton(methods, row, index) {
      this.$emit("handleButton", { methods: methods, row: row, index: index });
    },
    handleSortChange(val) {
      // 排序
      this.$emit("handleSortChange", val);
    },
    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
    },
    updataInfo() {
      this.$forceUpdate();
    },
    handleSizeChange(val) {
      this.$emit("handleSizeChange", val);
    },
    handleCurrentChange(val) {
      this.$emit("handleCurrentChange", val);
    },
    getRowKey(row) {
      return row[this.rowKey];
    },
    clear() {
      this.$refs.multipleTable.clearSelection();
    },
  },
};
</script>

<style scoped>
.table-expand {
  font-size: 0;
  display: flex;
  flex-wrap: wrap;
  padding-left: 60px;
}
.table-expand label {
  width: 90px;
  color: #99a9bf;
}
.table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>